import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import swal from 'sweetalert2';
import { environment } from '../../../../environments/environment';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { lastValueFrom } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-address-proof',
  templateUrl: './address-proof.component.html',
  styleUrls: ['./address-proof.component.scss'],
})
export class AddressProofComponent implements OnInit {
  baseUrl!: string;
  constructor(private router: Router, private sessionTimerService: SessionTimerService, private spinner: NgxSpinnerService, private route: ActivatedRoute, private accountService: AccountService) {
    this.baseUrl = environment.apiUrl + 'assistmodule/v1/documents/upload/address';
  }

  ngOnInit(): void {
    this.spinner.hide();

    //this.sessionTimerService.resumeTimer();
    this.route.queryParamMap.subscribe(async params => {

      // came form digitap unified kyc, handle success/failure
      let stat = params.get('status');
      let uniqueId = params.get('unifiedtransactionid');
      if (uniqueId) {
        this.initiateUKYC = false;
        this.displayVerification = true;
        this.spinner.show();
        try {
          await lastValueFrom(this.accountService.GetDetailsUKYC(uniqueId, stat));
        } catch (error) {
          console.error('Error fetching UKYC details:', error);
        }
        this.spinner.hide();
        return this.router.navigateByUrl('/assist-journey/professional-details');
      }

      // if pan & aadhaar are verified and Aadhaar verification is pending then comes here
      let status = params.get('showaadhaarinput');
      let status2 = params.get('showaadhaarotp');
      if (status === 'true' || status2 === 'true') {
        this.spinner.show();
        //swal.fire('Please proceed with aadhaar number');
        this.displayVerification = true;
        this.aadhaarOTPGenerated = false;
      }
    });
  }

  aadhaarOTPGenerated: boolean = false;
  displayVerification: boolean = false;
  initiateUKYC: boolean = true;
  documentNumber: string = '';
  ProceedToDocUpload(response: any) {
    this.spinner.show();
    if (response['error'] == null) {
      //swal.fire(response['data']['response_msg']);
      //success
      this.displayVerification = true;
      this.aadhaarOTPGenerated = true;
      this.documentNumber = response['data']['documentNumber'];
    }
    else if (response['error'] == 'Aadhaar Already Verified') {
      swal.fire('Aadhaar Already Verified');
      this.displayVerification = true;
      this.aadhaarOTPGenerated = false;
    }
    else if (response['error']['response_msg'] == 'exceed max tries for aadhaar upload') {
      swal.fire('Aadhaar verification failed, Please proceed with aadhaar number');
      this.displayVerification = true;
      this.aadhaarOTPGenerated = false;
    }
    else if (response['error']['response_summary'] == 'Aadhaar details do not match with user details.') {
      swal.fire('Please proceed with aadhaar number');
      this.displayVerification = true;
      this.aadhaarOTPGenerated = false;
    }
    else {
      this.displayVerification = false;
      this.aadhaarOTPGenerated = false;
      swal.fire(response['error']['response_summary']);
    }
    this.spinner.hide();
  }
}
